export default "__VITE_ASSET__fe762423__"